import { Theme } from '@mui/material';

import { sourceSansHeaders as sharpSansHeadersFont } from 'ha/constants/fonts/sourceSansHeaders';

export const supportUkraineTheme: (
  outerTheme: Theme,
  overrideSecondaryColor: boolean,
) => Theme = (outerTheme, overrideSecondaryColor) => ({
  ...outerTheme,
  overrides: {
    MuiToolbar: {
      root: {
        backgroundColor: '#0157B8',
        color: '#fff !important',
      },
    },
  },
  palette: {
    ...outerTheme.palette,
    primary: {
      main: '#0157B8',
      light: '#3378C6',
      dark: '#0c327c',
      contrastText: '#fff',
    },
    ...(overrideSecondaryColor
      ? {
          secondary: {
            main: '#FAD649',
            light: '#FBDE6D',
            dark: '#AF9533',
            contrastText: 'rgba(0, 0, 0, 0.87)',
          },
        }
      : {}),
  },
  typography: {
    ...outerTheme.typography,
    h1: {
      ...outerTheme.typography.h1,
      fontFamily: sharpSansHeadersFont.fontFamily,
    },
    h2: {
      ...outerTheme.typography.h2,
      fontFamily: sharpSansHeadersFont.fontFamily,
    },
    h3: {
      ...outerTheme.typography.h3,
      fontFamily: sharpSansHeadersFont.fontFamily,
    },
  },
});
